/** Strip a leading `v` and trim — used for tags like `v1.2.0`. */
export function normalizeReleaseVersion(version) {
    return version.trim().replace(/^v/i, '');
}
/** Release version: APP_VERSION env, then package.json, then fallback. */
export function resolveAppVersion(input) {
    const fromEnv = input.envVersion?.trim();
    if (fromEnv) {
        return normalizeReleaseVersion(fromEnv);
    }
    const fromPackage = input.packageJsonVersion?.trim();
    if (fromPackage) {
        return normalizeReleaseVersion(fromPackage);
    }
    return normalizeReleaseVersion(input.fallback?.trim() || '0.0.0');
}
/** Deploy build id (typically short git SHA), when injected at image/build time. */
export function resolveAppBuildSha(envBuildSha) {
    const trimmed = envBuildSha?.trim();
    return trimmed || undefined;
}
export function buildAppVersionInfo(version, buildSha) {
    return {
        version,
        ...(buildSha ? { buildSha } : {}),
    };
}
export function formatAppVersionCopyText(lines) {
    return lines.map(({ label, value }) => `${label}: ${value}`).join('\n');
}
/** User-facing deploy environment label (CI `development` → Staging). */
export function formatDeployEnvironmentLabel(deployEnvironment) {
    const normalized = deployEnvironment?.trim().toLowerCase();
    if (!normalized) {
        return undefined;
    }
    if (normalized === 'development') {
        return 'Staging';
    }
    if (normalized === 'production') {
        return 'Production';
    }
    return deployEnvironment?.trim();
}
export function buildAboutVersionCopyText(input) {
    const lines = [
        { label: 'Application', value: input.application },
        { label: 'Platform', value: input.platform },
        { label: 'Version', value: normalizeReleaseVersion(input.version) },
    ];
    if (input.commit) {
        lines.push({ label: 'Commit', value: input.commit });
    }
    if (input.apiCommit && input.apiCommit !== input.commit) {
        lines.push({ label: 'API commit', value: input.apiCommit });
    }
    const environment = formatDeployEnvironmentLabel(input.environment);
    if (environment) {
        lines.push({ label: 'Environment', value: environment });
    }
    return formatAppVersionCopyText(lines);
}
export function buildRepositoryCommitUrl(repositoryUrl, commitSha) {
    const sha = commitSha?.trim();
    if (!sha) {
        return undefined;
    }
    const base = repositoryUrl?.trim().replace(/\.git$/i, '').replace(/\/$/, '');
    if (!base) {
        return undefined;
    }
    return `${base}/commit/${sha}`;
}
//# sourceMappingURL=app-version.js.map